import { Goal } from "@curefit/gmf-common";
import * as _ from "lodash";
import { map as _map } from "lodash";
import * as React from "react";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import CustomSelect from "../CustomSelect";
import TextInput from "../TextInput";
import { ChangeEvent } from "react" 
import { IMetric } from "@curefit/metrics-common"

interface LCGoalItemEditorProps {
    item: any,
    staticGoals: Goal[],
    staticMetrics: IMetric[],
    onDataChange: (item: any) => void
}

export default class LCGoalItemEditor extends React.Component<LCGoalItemEditorProps> {
    private allergyItemDOM: any;

    constructor(props: LCGoalItemEditorProps) {
        super(props)
    }

    onGoalChange = (value: string) => {
        let updatedItem = { ...this.props.item, goalName: value };
        this.props.onDataChange(updatedItem);
    }

    onMetricChange = (value: string) => {
        let updatedItem = { ...this.props.item, metric: value };
        this.props.onDataChange(updatedItem);
    }

    onCurrentValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, current: e.target.value };
        this.props.onDataChange(updatedItem);
    }

    onTargetValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, target: e.target.value };
        this.props.onDataChange(updatedItem);
    }

    getGoalDropdownValues = (): IStaticDataValue[] => {
        return _map((this.props.staticGoals), (goal: Goal) => {
            return {
                displayValue: goal.name,
                internalValue: goal.name
            }
        })
    }

    getMetricDropdownValues = (): IStaticDataValue[] => {
        let values = null;
        if (this.props.item && this.props.item.goalName) {
            const goals = _.map(this.props.staticGoals, (goal: Goal) => ({
                goalName: goal.name,
                metricIds: goal.allowedMetricIds
            }));
            const selectedMetrics = goals.find((item: any) => item.goalName === this.props.item.goalName);
            if (selectedMetrics) {
                let updatedMetricsMap: {[key: string]: IMetric} = {};
                _.map(this.props.staticMetrics, (metric: IMetric) => {
                    updatedMetricsMap[metric.id] = metric;
                })
                values = selectedMetrics.metricIds.map((id: number) => {
                    const metric: any = updatedMetricsMap[id]
                    return {
                        displayValue: metric && metric.name,
                        internalValue: metric && metric.name
                    }
                })
            }
        }
        return values
    }

    render() {
        const { item } = this.props;
        const hasItemData = !_.isEmpty(item);
        const goalName = hasItemData ? item.goalName : "";
        const metric = hasItemData ? item.metric : "";
        const currentValue = hasItemData ? item.current : "";
        const targetValue = hasItemData ? item.target : "";
        return (
            <div className="allergy-item-editor" ref={(allergyItemDom) => this.allergyItemDOM = allergyItemDom}>
                <div className={`allergy-editor-allergen`}>
                    <CustomSelect dropdownValues={this.getGoalDropdownValues()} selectedValue={goalName} defaultValue={"Type"} updateDropdownValue={this.onGoalChange}/>
                </div>
                <div className={`allergy-editor-type`}>
                    <CustomSelect dropdownValues={this.getMetricDropdownValues()} selectedValue={metric} defaultValue={"Type"} updateDropdownValue={this.onMetricChange}/>
                </div>
                <div className="allergy-editor-suspected">
                    <TextInput name={"allergy-editor-suspected"} value={currentValue} onChange={this.onCurrentValueChange} />
                </div>
                <div className="allergy-editor-comment">
                    <TextInput name={"allergy-editor-suspected"} value={targetValue} onChange={this.onTargetValueChange} />
                </div>
            </div>
        )
    }
}